import Input from '../../../common/Input';
import {defaultDateFormat} from '../../../common/DatePicker';
import SimpleDatePicker from "../../../common/SimpleDatePicker";

export default {
    id: 0,

    name: 'vacations',
    _system: {
        name: 'Vacations',
        relatedTo: 'vacations',
    },
    date_from: {
        label: "Date From",
        hideLabel: true,
        placeholder: 'Add Date From',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            component: SimpleDatePicker,
            name: 'date_from',
            relatedTo: 'vacations'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'date_from',
        rules: {
            required: true,
            title: 'Date From field'
        }
    },
    date_to: {
        label: "Date To",
        hideLabel: true,
        placeholder: 'Add Date To',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            component: SimpleDatePicker,
            name: 'date_to',
            relatedTo: 'vacations'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'date_to',
        rules: {
            title: 'Date To field'
        }
    },
    number_of_working_days: {
        label: "Number Of Working Days",
        hideLabel: true,
        placeholder: 'Add Number Of Working Days',
        system: {
            component: Input,
            name: 'number_of_working_days',
            relatedTo: 'vacations'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'number_of_working_days',
        rules: {
            title: 'Number Of Working Days field',
            ignoreNull: true,
            numeric: true
        }
    },
    details: {
        label: "Details",
        hideLabel: true,
        placeholder: 'Add Details',
        system: {
            component: Input,
            name: 'details',
            relatedTo: 'vacations'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'details',
        rules: {
            title: 'Details field',
        },
        grid: {
            className: 'col col-5'
        }
    }
};



// WEBPACK FOOTER //
// ./src/containers/Employee/fields/vacations.js